// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__H87jl","col":"styles_col__8V_AL"};